import {
  ArticleCard,
  ArticleCardBody,
  ArticleCardHeader,
  ArticleCardLayout,
  ArticleCardMediaSkeleton,
  ArticleCardSummary,
  type ArticleCardVariant,
} from '@vs-shop/commerce-ui/articleCard';
import { Skeleton } from '@vs-shop/ui/skeleton';

type Props = {
  /** Required, for the reason {@link ArticlePreview}'s is: no arrangement by omission. */
  variant: ArticleCardVariant;
};

export default function ArticleSkeleton({ variant }: Props) {
  return (
    // Not `article-card`: the skeleton composes the card's own root, and a
    // listing counting its cards must not count the places still loading.
    <ArticleCard variant={variant} data-slot="article-card-skeleton">
      <ArticleCardLayout>
        <ArticleCardMediaSkeleton variant={variant}>
          <Skeleton className="h-full w-full rounded-lg" />
          {/* Badge skeleton */}
          <Skeleton className="absolute top-[5%] left-[5%] h-6 w-20 rounded-full" />
        </ArticleCardMediaSkeleton>

        <ArticleCardBody variant={variant}>
          <ArticleCardHeader>
            {/* Heading skeleton */}
            <div className="space-y-2">
              <Skeleton className="h-7 w-full @2xl:h-8" />
              <Skeleton className="h-7 w-3/4 @2xl:h-8" />
            </div>

            {/* ArticleInfoHeader skeleton */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-4 w-20" />
            </div>
          </ArticleCardHeader>

          {/* Description skeleton */}
          <ArticleCardSummary variant={variant}>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>
            <Skeleton className="h-5 w-40" />
          </ArticleCardSummary>
        </ArticleCardBody>
      </ArticleCardLayout>
    </ArticleCard>
  );
}
